module.exports = __webpack_public_path__ + "75d0916c90557057fe26f2769251ae37.svg";